import { render, staticRenderFns } from "./AddReportConfig.vue?vue&type=template&id=19830e4f&scoped=true&"
import script from "./AddReportConfig.vue?vue&type=script&lang=js&"
export * from "./AddReportConfig.vue?vue&type=script&lang=js&"
import style0 from "./AddReportConfig.vue?vue&type=style&index=0&id=19830e4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19830e4f",
  null
  
)

export default component.exports